<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M21 4C21.5523 4 22 3.55228 22 3C22 2.44772 21.5523 2 21 2H3C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4H21ZM12 6L11.918 6.004L11.7993 6.02024L11.6879 6.04974L11.5768 6.09367L11.4793 6.146L11.4048 6.19631L11.2929 6.29289L7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.29289 11.7071C7.65338 12.0676 8.22061 12.0953 8.6129 11.7903L8.70711 11.7071L11 9.415V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V9.415L15.2929 11.7071C15.6534 12.0676 16.2206 12.0953 16.6129 11.7903L16.7071 11.7071C17.0676 11.3466 17.0953 10.7794 16.7903 10.3871L16.7071 10.2929L12.7071 6.29289L12.6631 6.2515L12.5953 6.19633L12.4841 6.12467L12.4231 6.09365L12.3417 6.05989L12.266 6.03585L12.1175 6.00683L12 6Z"
    fill="currentColor"
  />
</svg>
